import { IChildrenProps } from '@/types/common.types'
import { memo } from 'react'

const BigContainer = memo(({ children }: IChildrenProps) => {
  return (
    <div className="mx-auto min-h-96 w-full max-w-6xl rounded-3xl bg-white px-4 py-12 shadow-form md:px-24">
      {children}
    </div>
  )
})

export default BigContainer
